import { render, staticRenderFns } from "./OAuthLogin.vue?vue&type=template&id=799c084d&scoped=true&"
import script from "./OAuthLogin.vue?vue&type=script&lang=js&"
export * from "./OAuthLogin.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&id=799c084d&scoped=true&lang=css&"
import style1 from "./OAuthLogin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c084d",
  null
  
)

export default component.exports